import { isLorebookStatusNeedReview } from "@next-platform/client-common-core";
import { CharacterCardVariant } from "@next-platform/client-common-spicy-ui";
import { Lorebook, ModerationStatus } from "@next-platform/packages-ts-types";

const getLorebookVariant = (lorebook: Lorebook) => {
  const variant = lorebook?.visibility
    ? CharacterCardVariant[lorebook?.visibility?.toUpperCase() as keyof typeof CharacterCardVariant]
    : CharacterCardVariant.DEFAULT;

  if (lorebook?.moderationReportStatus === ModerationStatus.FixRequired) {
    return CharacterCardVariant.ACTION;
  }

  if (lorebook?.moderationReportStatus === ModerationStatus.Pending || lorebook?.moderationReportStatus === ModerationStatus.RereviewRequired) {
    return CharacterCardVariant.REVIEW;
  }

  if (isLorebookStatusNeedReview(lorebook?.status, lorebook?.num_rejected_entries, lorebook?.num_needs_review_entries)) {
    return CharacterCardVariant.NEEDS_REVIEW;
  }

  return variant;
};

export default getLorebookVariant;
